import { render, staticRenderFns } from "./SlotMain.vue?vue&type=template&id=6b820252&scoped=true"
import script from "./SlotMain.vue?vue&type=script&lang=js"
export * from "./SlotMain.vue?vue&type=script&lang=js"
import style0 from "./SlotMain.vue?vue&type=style&index=0&id=6b820252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b820252",
  null
  
)

export default component.exports